import { Customer, Traveler } from '@/src/types/itinerary'
import { calculateAge } from '@/src/utils/date/ageCalculator'
import { titleToGenderMap } from '@/src/utils/itinerary/genderToTitleMap'

export const getGtmPayloadForPayment = ({
    primaryTraveler,
    contactDetails
}: {
    primaryTraveler: Traveler
    contactDetails: Customer
}) => {
    const { dateOfBirth, firstName, lastName, documentDetails, nationality, selectedDocumentType, title } =
        primaryTraveler || {}
    const { nationality: travelerNationality } = documentDetails?.[selectedDocumentType!] || {}
    const { day, month, year } = dateOfBirth || {}
    const { email, mobile, mobileCountryCode } = contactDetails || {}
    const userDob = `${day}/${month}/${year}`
    const userPhone = `+${mobileCountryCode}${mobile}`
    return {
        user_email: email,
        user_phone: `+${mobileCountryCode}${mobile}`,
        user_first_name: firstName,
        user_last_name: lastName,
        user_birth_date: userDob,
        user_age: calculateAge(userDob),
        user_nationality: nationality || travelerNationality || '',
        user_gender: titleToGenderMap(title).toLowerCase(),
        user_email_phone: `{"user_email":"${email || 'not_informed'}","user_phone":"${userPhone || 'not_informed'}"}`
    }
}
